import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { state } from "./store";
import "./registerServiceWorker";

import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);

// import $ from 'jquery';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    // created時に初期StateをsessionStorageに保存しておく。
    sessionStorage.setItem("state", JSON.stringify(state));
  }
}).$mount("#app");
